import React from 'react';
import { Bell } from 'lucide-react';
interface TopBarProps {
  title: React.ReactNode;
  subtitle?: string;
  actions?: React.ReactNode;
  notifications?: React.ReactNode;
}
export function TopBar({
  title,
  subtitle,
  actions,
  notifications
}: TopBarProps) {
  return <header className="flex items-center justify-between gap-4 border-b border-slate-200 bg-white px-6 py-4" data-id="element-2496" data-mp="2y2e73wmsay7e">
      <div className="min-w-0" data-id="element-2497" data-mp="3pr7h3cmlff8j">
        {typeof title === 'string' ? <h1 className="truncate font-[Figtree] text-xl font-semibold text-evergreen" data-id="element-2498" data-mp="3ptaiest74usk">{title}</h1> : title}
        {subtitle && <p className="mt-0.5 truncate text-sm text-slate-500" data-id="element-2499" data-mp="3gzp2v797j9i3">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3" data-id="element-2500" data-mp="3kzz82hp6dvvw">
        {actions}
        {notifications ?? <button type="button" aria-label="Notifications, 12 unread" className="relative rounded-lg p-2 text-slate-500 transition hover:bg-slate-100 hover:text-evergreen" data-id="element-2501" data-mp="ck5sq66kyqgf">
            <Bell className="h-5 w-5" data-id="element-2502" data-mp="2n63q3pihn4ca" />
            <span className="absolute -right-0.5 -top-0.5 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold text-white" data-id="element-2503" data-mp="2n2zfa9aipacn">
              12
            </span>
          </button>}
      </div>
    </header>;
}